const MODULE_LABELS = {
  VISA: "Visa",
  INSURANCE: "Insurance",
  RPL_CLIENT: "RPL",
  SKILL_ASSESSMENT: "Skill assessment",
  ADMISSION: "Admission",
  OTHER: "Other",
};

export const moduleEntryLabel = (entry) => {
  const moduleName = MODULE_LABELS[entry?.moduleType] || entry?.moduleType || "Entry";
  const own = String(entry?.entryLabel || entry?.label || "").trim();
  return own ? `${moduleName} — ${own}` : `${moduleName} — entry ${entry?.entryId}`;
};

export const assigneeOptionsFor = (client) => {
  const options = [{ value: "CLIENT", label: "The client" }];
  if (client?.referralPartnerId) {
    options.push({
      value: "PARTNER",
      label: `${
        client.referralPartnerName || client.referral || "Referral partner"
      } (referral partner)`,
    });
  }
  return options;
};

export const buildRequestPayload = (form) => {
  const payload = {
    title: String(form?.title || "").trim(),
    items: (form?.items || []).map((item) => ({
      label: item.label,
      required: Boolean(item.required),
      instructions: item.instructions || "",
      maxFiles: item.maxFiles === "" || item.maxFiles == null ? null : Number(item.maxFiles),
    })),
    assigneeType: form?.assignee || "CLIENT",
  };
  if (payload.assigneeType === "PARTNER") {
    payload.assigneePartnerId = form.assigneePartnerId;
  }
  if (form?.targetModule) {
    payload.targetModuleType = form.targetModule.moduleType;
    payload.targetModuleEntryId = form.targetModule.entryId;
  }
  return payload;
};
